import React, { useState, useEffect, useRef } from "react";
import MomentumLogo from '../assets/images/momentum-ai-logo.png';
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function ValidationPage() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [errorState, setErrorState] = useState(false);
    const [validationStep, setValidationStep] = useState(0);

    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");

    useEffect(() => {
        localStorage.clear();
        validateNowcertsToken(token);
    }, []);

    const validateNowcertsToken = (token: any) => {
        setLoading(true);
        setErrorState(false);

        axios({
            method: "get",
            // url: `${process.env.REACT_APP_AMP_API_Url}/api/account/validatessotoken?token=${token}`,
            url: `https://momentumampapi-stage.insurancegig.com/api/account/validatessotoken?token=${token}`,
        })
            .then((response: any) => {
                if (!response.data?.authToken) {
                    localStorage.clear();
                    setErrorState(true);
                    setLoading(false);
                    return;
                }

                localStorage.setItem("authToken", response.data.authToken);
                localStorage.setItem("amsToken", response.data.amsToken);
                localStorage.setItem("userName", response.data.userName);
                localStorage.setItem("agency", response.data.agencyName);
                localStorage.setItem("NowcertsAgentId", response.data.nowCertsAgentId);                
                localStorage.setItem("NCAgencyId", response.data.nowCertsAgencyId);
                
                setLoading(false);
                const guid = generateGuid();
                navigate(`/supportbot/${guid}`);
            })
            .catch((error: any) => {
                setLoading(false);
                setErrorState(true);

                if (error.response?.status === 401) {
                    localStorage.clear();
                    // navigate("/");
                } else {
                    // toast.current?.show({
                    //     severity: "error",
                    //     summary: "Error",
                    //     detail: "Unknown error while validating token!",
                    //     life: 3000,
                    // });
                }
            });
    };

    const generateGuid = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    return (
        <div className="hub-container">
            <div className="hub-bg-overlay" />

            <header className="hub-header">
                <div className="hub-logo-section" style={{ paddingRight: '24px' }}>
                    <div className="hub-logo-icon" style={{ width: '170px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <img src={MomentumLogo} alt="Momentum Logo" style={{ width: '160px', height: '40px', objectFit: 'contain', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.05))' }} />
                    </div>
                </div>
            </header>

            <div className="validation-wrapper">
                <div className="validation-card">
                    <div className="validation-header">
                        <div className="validation-icon-container">
                            {loading ? (
                                <div className="validation-loading-icon">
                                    <svg className="validation-spinner" viewBox="0 0 24 24">
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            fill="none"
                                            stroke="var(--accent-color)"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeDasharray="31.416"
                                            strokeDashoffset="31.416"
                                        >
                                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite" />
                                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite" />
                                        </circle>
                                    </svg>
                                </div>
                            ) : errorState ? (
                                <div className="validation-error-icon">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="10" fill="#ef4444" />
                                        <path d="M15 9l-6 6m0-6l6 6" stroke="white" strokeWidth="2" />
                                    </svg>
                                </div>
                            ) : (
                                <div className="validation-success-icon">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="10" fill="#0da853" />
                                        <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" />
                                    </svg>
                                </div>
                            )}
                        </div>

                        <h1 className={`validation-title ${!loading && errorState ? "validation-title-error" : ""}`}>
                            {loading ? "Authenticating..." : errorState ? "Access Denied" : "Validation Complete!"}
                        </h1>

                        <p className="validation-subtitle">
                            {loading
                                ? "Please wait while we verify your access..."
                                : errorState
                                    ? "Your credentials could not be verified or you don't have permission to access this system."
                                    : "Welcome to your secure insurance dashboard"}
                        </p>

                        <div className="validation-icon-container">
                            <button type="button" className="hub-btn hub-btn-signin" onClick={() => window.location.href = '/'}>Back to Chat</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}
